import { createAsyncThunk } from '@reduxjs/toolkit';
import AuthServiceHelper, {
  IGetClientCredentialsToken,
} from './AuthServiceHelper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getClientCredentialsToken: any = createAsyncThunk(
  'auth/client_credentials',
  async (data: IGetClientCredentialsToken) => {
    const res = await AuthServiceHelper.getClientCredentialsToken(data);
    return res;
  }
);

export default getClientCredentialsToken;
